import { Component, Input } from '@angular/core';
import { Step } from '@nx-ng/types';

@Component({
  selector: 'nx-ng-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input()
  currentStep: Step | undefined = 'tickets';

  // There is an inherent order baked into this component
  private order: Step[] = ['tickets', 'results', 'details', 'confirmation'];

  public ariaCurrentFor(crumb: Step): string | undefined {
    if (crumb === this.currentStep) {
      return 'page';
    }
    return undefined;
  }

  public getClassFor(crumb: Step): string {
    if (!this.currentStep) {
      return '';
    }
    if (crumb === this.currentStep) {
      return 'current';
    }
    const currentStepIndex = this.order.indexOf(this.currentStep);
    const crumbStepIndex = this.order.indexOf(crumb);

    if (crumbStepIndex > currentStepIndex) {
      return 'future';
    }
    return 'past';
  }
}
